(() => {
  const panel = document.querySelector('[data-commercial-panel]');
  if (!panel || panel.hasAttribute('data-evasion-edition')) return;
  const preopeningLocked = document.documentElement.dataset.roscoffPreopeningLocked !== 'false';
  const preopeningLabel = document.documentElement.dataset.roscoffPreopeningLabel;
  const catalog = window.ROSCOFF_COMMERCE;
  const product = catalog?.products?.[panel.dataset.artworkRef];
  if (!product) return;
  const framedPrototype = document.querySelector('[data-equilibre-framed-images]') ? window.ROSCOFF_EQUILIBRE_FRAMED : null;
  const sharedGallery = window.ROSCOFF_EQUILIBRE_FRAMED;
  const isSharedAlu = () => support === 'alu-dibond' && !!sharedGallery?.openGallery;
  let aluGalleryItems = [];
  const isFramedPrototype = () => !!framedPrototype && support === 'encadre';
  const passageFramed = panel.dataset.artworkRef === 'A6 V2' && document.querySelector('[data-equilibre-framed-images]') ? JSON.parse(document.querySelector('[data-equilibre-framed-images]').textContent) : null;
  const newFramed32 = framedPrototype && document.querySelector('[data-equilibre-framed-images]') ? JSON.parse(document.querySelector('[data-equilibre-framed-images]').textContent).newFramed32 === true : false;
  const isA13 = panel.dataset.artworkRef === 'A13 V2';
  let validatedAlu = null;
  try {
    const source = document.querySelector('[data-alu-images], [data-reine-alu-images]');
    validatedAlu = source ? JSON.parse(source.textContent) : null;
  } catch {}
  const isValidatedAlu = () => support === 'alu-dibond'
    && validatedAlu?.reference === panel.dataset.artworkRef
    && validatedAlu.formats?.[format]?.images?.length === (isA13 && validatedAlu.mockupCount === 4 ? 4 : 3);

  const deliveryConfigNode = panel.querySelector('[data-delivery-config]');
  let deliveryConfig = {};
  try { deliveryConfig = JSON.parse(deliveryConfigNode?.textContent || '{}'); } catch {}
  let smallFramedConfig = {};
  try { smallFramedConfig = JSON.parse(panel.querySelector('[data-small-framed-config]')?.textContent || '{}'); } catch {}
  const framedStockNode = panel.querySelector('[data-encadre-stock]');
  let framedStock = {};
  try { framedStock = JSON.parse(framedStockNode?.textContent || '{}'); } catch { /* Fail closed for Encadre. */ }
  const framedAvailable = (formatId) => {
    const id = catalog.shopifyVariantIds?.[panel.dataset.artworkRef]?.encadre?.[formatId];
    return framedStock[String(id)]?.available === true;
  };
  const framedUnavailableLabel = framedStockNode?.dataset.unavailableLabel || '';
  const framedOrderInfo = panel.querySelector('[data-encadre-order-info]');
  const framedOrderLabels = framedOrderInfo?.dataset || {};

  const supportButtons = [...panel.querySelectorAll('[data-support]')];
  const formats = panel.querySelector('[data-format-options]');
  const frameInfo = panel.querySelector('[data-frame-info]');
  const framedDimensions = {
    F1: {imageCm: [32, 18], label: '40 × 30 cm'},
    F2: {imageCm: [48, 27], label: '60 × 40 cm'},
    F3: {imageCm: [64, 36], label: '70 × 50 cm'},
    F4: {imageCm: [80, 45], label: '90 × 60 cm'}
  };
  const dimension = panel.querySelector('[data-commercial-dimension]');
  const state = panel.querySelector('[data-commercial-state]');
  const note = panel.querySelector('[data-commercial-note]');
  const price = panel.querySelector('[data-commercial-price]');
  const description = panel.querySelector('[data-support-description]');
  const previews = document.querySelector('[data-support-previews]');
  const previewGrid = previews?.querySelector('[data-support-preview-grid]');
  const artworkThumb = document.querySelector('.product-gallery .gallery-thumb');
  const imageSource = artworkThumb?.querySelector('img')?.getAttribute('src');
  const imageLarge = artworkThumb?.dataset.gallerySrc || imageSource;
  const mainMedia = document.querySelector('.artwork-main-image');
  const tactileQuery = matchMedia('(hover: none), (pointer: coarse)');
  const counter = document.createElement('p');
  counter.className = 'roscoff-gallery-counter';
  counter.setAttribute('aria-live', 'polite');
  const galleryStage = document.createElement('div');
  galleryStage.className = 'roscoff-gallery-stage';
  if (mainMedia) { mainMedia.before(galleryStage); galleryStage.append(mainMedia); galleryStage.after(counter); }
  const directions = [-1, 1].map(direction => {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = `roscoff-gallery-direction ${direction < 0 ? 'is-previous' : 'is-next'}`;
    button.setAttribute('aria-label', direction < 0 ? 'Présentation précédente' : 'Présentation suivante');
    button.innerHTML = '<span aria-hidden="true"></span>';
    button.addEventListener('click', event => { event.stopPropagation(); movePreview(direction); });
    galleryStage.append(button);
    return button;
  });
  const tactileNavigation = document.createElement('div');
  tactileNavigation.className = 'roscoff-tactile-navigation';
  function positionNavigation() {
    if (!mainMedia) return;
    if (tactileQuery.matches) {
      galleryStage.after(tactileNavigation);
      tactileNavigation.append(directions[0], counter, directions[1]);
    } else {
      directions.forEach(button => galleryStage.append(button));
      galleryStage.after(counter);
      tactileNavigation.remove();
    }
  }
  const orientationCaption = isA13 ? document.createElement('p') : null;
  if (orientationCaption) {
    orientationCaption.className = 'roscoff-orientation-caption';
    orientationCaption.textContent = product.orientationNote;
  }
  function placeOrientationCaption() {
    if (!orientationCaption) return;
    if (support === 'photo') galleryStage.after(orientationCaption);
    else previewGrid.after(orientationCaption);
  }
  function movePreview(direction) {
    if (isFramedPrototype() || isSharedAlu() || !previewNames[support]) return;
    const count = previewNames[support].length;
    selectPreview((activePreview + direction + count) % count);
    const target = currentPreview || mainMedia.querySelector('.main-gallery-track');
    if (target?.animate && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
      target.animate([{opacity: .85, translate: `${direction * 14}px 0`}, {opacity: 1, translate: '0 0'}], {duration: 170, easing: 'ease-out'});
    }
  }
  function syncGalleryAccess() {
    const count = (isFramedPrototype() || isSharedAlu()) ? 1 : previewNames[support]?.length || 1;
    positionNavigation();
    tactileNavigation.hidden = count === 1;
    counter.hidden = count === 1;
    directions.forEach(button => { button.hidden = count === 1 || !tactileQuery.matches; });
    counter.textContent = `${activePreview + 1} / ${count}`;
    if (!mainMedia) return;
    if (tactileQuery.matches) {
      mainMedia.removeAttribute('role');
      mainMedia.removeAttribute('tabindex');
      mainMedia.setAttribute('aria-label', count > 1 ? 'Présentations de l’œuvre — balayez vers la gauche ou la droite' : 'Photographie de l’œuvre');
      mainMedia.classList.remove('is-zooming');
    }
  }
  tactileQuery.addEventListener('change', () => {
    if (tactileQuery.matches) document.querySelector('#image-lightbox:not([hidden]) .lightbox-close')?.click();
    if (!tactileQuery.matches && mainMedia) { mainMedia.setAttribute('role', 'button'); mainMedia.setAttribute('tabindex', '0'); mainMedia.setAttribute('aria-label', 'Agrandir la présentation'); }
    syncGalleryAccess();
  });
  let originalMainLabel = mainMedia?.getAttribute('aria-label');
  const descriptions = {
    photo: description.dataset.photoDescription,
    'alu-dibond': panel.querySelector('[data-alu-summary]').textContent.trim(),
    encadre: description.dataset.encadreDescription
  };
  const previewNames = product.mockupsPending ? {} : {
    'alu-dibond': ['L’œuvre', 'Mise en situation', 'Détail de l’image', 'Vue du bord', 'Autre angle'],
    encadre: ['L’œuvre', 'Mise en situation', 'Détail du cadre', 'Bord et passe-partout', 'Autre angle']
  };
  if (isA13) {
    previewNames['alu-dibond'][4] = 'Présentation verticale';
    previewNames.encadre[4] = 'Présentation verticale';
  }
  const previewIndices = isA13 ? [1, 2, 3, 4] : [1, 2, 4];
  Object.keys(previewNames).forEach(key => { previewNames[key] = previewIndices.map(index => previewNames[key][index]); });
  if (validatedAlu) previewNames['alu-dibond'] = ['Mise en situation', 'Détail Alu Dibond', 'Autre angle'];
  let support = 'photo';
  let format = 'F1';
  const requestedVariantId = new URLSearchParams(window.location.search).get('variant');
  if (requestedVariantId) {
    for (const button of supportButtons) {
      const candidateSupport = button.dataset.support;
      const candidateFormat = catalog.formats.find(item =>
        String(catalog.shopifyVariantIds?.[panel.dataset.artworkRef]?.[candidateSupport]?.[item.id] || '') === requestedVariantId
        && product.supports[candidateSupport]?.[item.id]?.availability === 'available');
      if (candidateFormat) {
        support = candidateSupport;
        format = candidateFormat.id;
        break;
      }
    }
  }
  let activePreview = 0;
  let currentPreview = null;
  const number = (value, digits = 1) => new Intl.NumberFormat('fr-FR', {maximumFractionDigits: digits}).format(value);
  const label = (offer) => `${number(offer.widthCm)} × ${number(offer.heightCmDisplay, offer.widthCm === 100 ? 2 : 1)} cm`;

  function openAluGallery(index, trigger) {
    if (!isSharedAlu() || !aluGalleryItems.length) return;
    sharedGallery.openGallery(aluGalleryItems, index, trigger);
  }


  function selectPreview(index) {
    if (isSharedAlu()) { openAluGallery(index, previewGrid?.querySelectorAll('button')[index]); return; }
    if (isFramedPrototype() || !mainMedia || !previewGrid || !previewNames[support]) return;
    const buttons = [...previewGrid.querySelectorAll('.support-preview')];
    if (!buttons[index]) return;
    activePreview = index;
    syncGalleryAccess();
    buttons.forEach((button, position) => {
      const selected = position === index;
      button.classList.toggle('is-active', selected);
      button.setAttribute('aria-pressed', String(selected));
    });
    currentPreview?.remove();
    currentPreview = null;
    if (!mainMedia.classList.contains('has-support-preview')) originalMainLabel = mainMedia.getAttribute('aria-label');
    currentPreview = buttons[index].querySelector('.support-preview-stage').cloneNode(true);
    currentPreview.classList.add('support-preview-main', `support-preview-${previewIndices[index] + 1}`);
    currentPreview.querySelector('img').src = imageLarge;
    currentPreview.setAttribute('role', 'img');
    currentPreview.setAttribute('aria-label', `${previewNames[support][index]} : aperçu indicatif`);
    mainMedia.append(currentPreview);
    mainMedia.classList.add('has-support-preview');
    mainMedia.setAttribute('role', 'button');
    mainMedia.setAttribute('tabindex', '0');
    mainMedia.setAttribute('aria-label', `Agrandir ${previewNames[support][index]} : aperçu indicatif`);
    syncGalleryAccess();
      mainMedia.dispatchEvent(new CustomEvent('roscoff:gallery-select', {detail: {index}}));
  }

  function renderPreviews() {
    activePreview = 0;
    aluGalleryItems = [];
    placeOrientationCaption();
    if (passageFramed && mainMedia) {
      const src = support === 'encadre' && format === 'F1' ? passageFramed.master : imageLarge;
      mainMedia.querySelector('picture source').srcset = src;
      mainMedia.querySelector('picture img').src = src;
    }
    if (description) description.textContent = descriptions[support];
    if (!previews || !previewGrid) return;
    currentPreview?.remove();
    currentPreview = null;
    mainMedia?.classList.remove('has-support-preview');
    mainMedia?.classList.toggle('has-product-gallery', !isFramedPrototype() && !!imageSource && !!previewNames[support]);
    previews.classList.toggle('is-equilibre-framed', isFramedPrototype());
    previews.classList.toggle('is-alu-shared', isSharedAlu());
    mainMedia?.classList.remove('has-reine-alu-gallery');
    previews.classList.toggle('is-reine-alu', isValidatedAlu());
    if (validatedAlu) { artworkThumb?.classList.add('is-active'); artworkThumb?.setAttribute('aria-pressed', 'true'); }

    framedPrototype?.close();
    if (mainMedia) mainMedia.dataset.presentation = support;
    if (mainMedia) {
      mainMedia.setAttribute('role', 'button');
      mainMedia.setAttribute('tabindex', '0');
      mainMedia.setAttribute('aria-label', originalMainLabel);
    }
    previewGrid.replaceChildren();
    previews.hidden = !imageSource || (!previewNames[support] && !((passageFramed || newFramed32) && isFramedPrototype()));
    syncGalleryAccess();
    if (previews.hidden) {
      mainMedia?.dispatchEvent(new CustomEvent('roscoff:gallery', {detail: {items: null}}));
      return;
    }
    previews.dataset.presentation = support;
    if (isFramedPrototype()) {
      previews.hidden = !framedPrototype.render(previewGrid, format);
      mainMedia?.dispatchEvent(new CustomEvent('roscoff:gallery', {detail: {items: null}}));
      return;
    }
    if (isValidatedAlu()) {
      const items = validatedAlu.formats[format].images;
      items.forEach((item, index) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'support-preview';
        button.setAttribute('aria-label', `Afficher : ${item.label}`);
        button.setAttribute('aria-pressed', 'false');
        const stage = document.createElement('div');
        stage.className = 'support-preview-stage roscoff-alu-validated';
        const image = document.createElement('img');
        image.src = item.src;
        image.alt = item.alt;
        image.width = 1448;
        image.height = 1086;
        image.loading = 'lazy';
        image.draggable = false;
        stage.append(image);
        const caption = document.createElement('span');
        caption.className = 'support-preview-caption';
        caption.textContent = item.label;
        button.append(stage, caption);
        button.setAttribute('aria-haspopup', 'dialog');
        button.addEventListener('click', () => selectPreview(index));
        previewGrid.append(button);
      });
      aluGalleryItems = items;
      mainMedia.dispatchEvent(new CustomEvent('roscoff:gallery', {detail: {items: null}}));
      return;
    }
    previewNames[support].forEach((name, index) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = `support-preview support-preview-${previewIndices[index] + 1}`;
      button.setAttribute('aria-label', `Afficher : ${name}${index ? ', aperçu indicatif' : ''}`);
      const stage = document.createElement('div');
      stage.className = 'support-preview-stage';
      if (isA13 && previewIndices[index] === 4) stage.classList.add('is-vertical');
      stage.style.setProperty('--preview-image', `url("${imageSource}")`);
      const mount = document.createElement('div');
      mount.className = 'support-preview-mount';
      const image = document.createElement('img');
      image.src = imageSource;
      image.alt = '';
      image.loading = 'lazy';
      mount.append(image);
      stage.append(mount);
      const caption = document.createElement('span');
      caption.className = 'support-preview-caption';
      caption.textContent = name;
      button.append(stage, caption);
      button.addEventListener('click', () => selectPreview(index));
      previewGrid.append(button);
    });
    if (isSharedAlu()) {
      const buttons = [...previewGrid.querySelectorAll('.support-preview')];
      buttons.forEach(button => button.setAttribute('aria-haspopup', 'dialog'));
      aluGalleryItems = buttons.map((button, index) => ({
          label: previewNames[support][index], src: imageLarge,
          stage: button.querySelector('.support-preview-stage').cloneNode(true),
          viewClass: `support-preview-${previewIndices[index] + 1}`
        }));
      mainMedia.dispatchEvent(new CustomEvent('roscoff:gallery', {detail: {items: null}}));
      return;
    }
    mainMedia.dispatchEvent(new CustomEvent('roscoff:gallery', {detail: {
      support,
      items: [...previewGrid.querySelectorAll('.support-preview')].map((button, index) => ({
        label: previewNames[support][index],
        src: imageLarge,
        viewIndex: previewIndices[index],
        stage: button.querySelector('.support-preview-stage').cloneNode(true)
      }))
    }}));
    selectPreview(0);
  }

  mainMedia?.addEventListener('roscoff:select-preview', (event) => selectPreview(event.detail.index));

  // The same active preview is used by thumbnails and horizontal touch gestures.
  let touchStart = null;
  let swipeJustEnded = false;
  mainMedia?.addEventListener('touchstart', (event) => {
    if (isFramedPrototype() || isSharedAlu() || !previewNames[support] || event.touches.length !== 1) return;
    touchStart = {x: event.touches[0].clientX, y: event.touches[0].clientY};
  }, {passive: true});
  mainMedia?.addEventListener('touchend', (event) => {
    if (isFramedPrototype() || isSharedAlu() || !touchStart || !previewNames[support] || event.changedTouches.length !== 1) return;
    const dx = event.changedTouches[0].clientX - touchStart.x;
    const dy = event.changedTouches[0].clientY - touchStart.y;
    touchStart = null;
    if (Math.abs(dx) < 45 || Math.abs(dx) <= Math.abs(dy) * 1.3) return;
    swipeJustEnded = true;
    movePreview(dx < 0 ? 1 : -1);
    window.setTimeout(() => { swipeJustEnded = false; }, 450);
  }, {passive: true});
  mainMedia?.addEventListener('touchcancel', () => { touchStart = null; }, {passive: true});
  mainMedia?.addEventListener('click', (event) => {
    if (!swipeJustEnded) return;
    event.preventDefault();
    event.stopPropagation();
    swipeJustEnded = false;
  }, true);

  function render() {
    const offers = product.supports[support];
    if (offers[format]?.availability !== 'available') {
      format = catalog.formats.find(item => offers[item.id]?.availability === 'available')?.id;
    }
    if (!format) return;
    supportButtons.forEach((button) => {
      const active = button.dataset.support === support;
      button.classList.toggle('is-selected', active);
      button.setAttribute('aria-pressed', String(active));
    });
    formats.replaceChildren();
    for (const item of catalog.formats) {
      const offer = product.supports[support][item.id];
      if (!offer || offer.availability === 'custom_only' || (support === 'encadre' && !['F1', 'F2', 'F3', 'F4', 'F5'].includes(item.id))) continue;
      const button = document.createElement('button');
      button.type = 'button';
      button.textContent = offer.availability === 'custom_only'
        ? `${label(offer)} — ${panel.dataset.onRequestLabel}` : label(offer);
      button.dataset.format = item.id;
      const frameUnavailable = support === 'encadre' && offer.availability === 'available' && !framedAvailable(item.id);
      button.disabled = offer.availability === 'custom_only';
      button.classList.toggle('is-unavailable', frameUnavailable);
      button.classList.toggle('is-selected', item.id === format && !button.disabled);
      button.setAttribute('aria-pressed', String(item.id === format && !button.disabled));
      if (button.disabled) button.title = 'Uniquement sur demande';
      button.addEventListener('click', () => {
        format = item.id;
        if (isFramedPrototype() || isSharedAlu()) renderPreviews();
        render();
      });
      formats.append(button);
    }
    const selected = product.supports[support][format];
    const kitVariant = support === 'alu-dibond'
      ? catalog.shopifyAluKitVariants?.[panel.dataset.artworkRef]?.[format] : null;
    const selectedPrice = support === 'alu-dibond' ? kitVariant?.priceTtc : selected.priceTtc;
    const includedKit = panel.querySelector('[data-alu-kit-included]');
    if (includedKit) includedKit.hidden = support !== 'alu-dibond' || !kitVariant;
    const framedBenefits = panel.querySelector('[data-framed-benefits]');
    if (framedBenefits) framedBenefits.hidden = support !== 'encadre' || panel.dataset.artworkRef === 'A12 V222';
    if (frameInfo) {
      const standard = framedDimensions[format];
      const isStandard = standard && selected.widthCm === standard.imageCm[0]
        && Math.abs(selected.heightCmExact - standard.imageCm[1]) < 0.001;
      const evasionFrames = panel.dataset.artworkRef === 'A12 V222'
        ? {F1: '40 × 20 cm', F2: '60 × 30 cm', F3: '80 × 40 cm', F4: '90 × 50 cm'} : null;
      const frameLabel = evasionFrames?.[format] || ((isStandard || panel.dataset.artworkRef === 'A4 V22') && standard ? standard.label : '');
      frameInfo.hidden = support !== 'encadre';
      frameInfo.querySelector('[data-frame-dimensions-line]').hidden = !frameLabel;
      frameInfo.querySelector('[data-frame-dimensions]').textContent = frameLabel.replaceAll(' ', '\u00a0');
    }
    panel.querySelector('[data-alu-summary]').hidden = support !== 'alu-dibond';
    panel.querySelectorAll('[data-alu-property]').forEach(input => { input.disabled = support !== 'alu-dibond'; });
    const detailImage = panel.querySelector('[data-support-detail-image]');
    const detailBody = panel.querySelector('.roscoff-support-detail-body');
    if (detailImage) {
      const imageData = panel.querySelector('[data-support-detail-images]');
      const detailSources = imageData ? JSON.parse(imageData.textContent) : {};
      const aluPresentationDetail = support === 'alu-dibond'
        ? previewGrid?.children[1]?.querySelector('img')?.getAttribute('src') : null;
      const detailSource = aluPresentationDetail || detailSources[support]?.[format]
        || (support !== 'encadre' ? detailImage.dataset.artworkImage : null);
      detailImage.hidden = !detailSource;
      detailBody.classList.toggle('has-support-image', !!detailSource);
      if (detailSource && detailImage.getAttribute('src') !== detailSource) detailImage.src = detailSource;
    }
    dimension.textContent = label(selected).replaceAll(' ', '\u00a0');
    dimension.hidden = false;
    panel.querySelectorAll('[data-support-detail]').forEach(detail => {
      detail.hidden = detail.dataset.supportDetail !== support;
    });
    const hasValidatedPrice = selected.priceValidated === true && selected.availability === 'available'
      && Number.isFinite(selectedPrice) && selectedPrice > 0;
    const priceNote = panel.querySelector('[data-price-note]');
    if (priceNote) priceNote.hidden = !hasValidatedPrice;
    const selectedVariantId = support === 'alu-dibond' ? kitVariant?.id
      : catalog.shopifyVariantIds?.[panel.dataset.artworkRef]?.[support]?.[format];
    const smallPrepared = support === 'encadre' && [32, 48].includes(selected.widthCm)
      && panel.dataset.artworkRef !== 'A12 V222' && hasValidatedPrice;
    const smallTerms = smallPrepared ? smallFramedConfig[String(selected.widthCm)] : null;
    const smallWindowValid = !smallPrepared || selected.widthCm !== 32
      || (Number.isFinite(Date.parse(smallTerms?.acceptUntil)) && Date.now() <= Date.parse(smallTerms.acceptUntil));
    const smallDocumented = smallPrepared && smallTerms?.deliveryConfirmed === true && smallWindowValid
      && typeof smallTerms.deliveryText === 'string' && smallTerms.deliveryText.trim().length > 0;
    const supportDelivery = deliveryConfig[support] || {};
    const selectedFramedStock = support === 'encadre' ? framedStock[String(selectedVariantId)] : null;
    const selectedDelivery = {...supportDelivery, ...(supportDelivery.variants?.[String(selectedVariantId)] || {}),
      ...(selectedFramedStock?.available === true ? {
        estimate: selectedFramedStock.estimate || null,
        reinforcedPackaging: selectedFramedStock.reinforcedPackaging === true
      } : {})};
    const deliveryEligible = selected.availability === 'available'
      && (!Array.isArray(selectedDelivery.standardWidthsCm) || selectedDelivery.standardWidthsCm.includes(selected.widthCm))
      && (support !== 'encadre' || (panel.dataset.artworkRef !== 'A12 V222' && framedAvailable(format)));
    const estimate = smallDocumented ? smallTerms.estimate : selectedDelivery.estimate;
    const hasEstimate = deliveryEligible && Number.isInteger(estimate?.minDays)
      && Number.isInteger(estimate?.maxDays) && estimate.minDays > 0 && estimate.maxDays >= estimate.minDays;
    const estimateRow = panel.querySelector('[data-reassurance-estimate]');
    if (estimateRow) {
      estimateRow.hidden = !hasEstimate && !smallDocumented;
      const estimateText = estimateRow.querySelector('[data-delivery-estimate-template]');
      if (estimateText) estimateText.textContent = smallDocumented ? smallTerms.deliveryText : hasEstimate
        ? estimateText.dataset.deliveryEstimateTemplate.replace('__MIN_DAYS__', estimate.minDays).replace('__MAX_DAYS__', estimate.maxDays) : '';
    }
    const packagingRow = panel.querySelector('[data-reassurance-packaging]');
    if (packagingRow) packagingRow.hidden = smallDocumented ? smallTerms.reinforcedPackaging !== true : !deliveryEligible || selectedDelivery.reinforcedPackaging !== true;
    price.hidden = !hasValidatedPrice;
    price.textContent = hasValidatedPrice
      ? new Intl.NumberFormat('fr-FR', {style: 'currency', currency: 'EUR',
          ...(Number.isInteger(selectedPrice)
            ? {minimumFractionDigits: 0, maximumFractionDigits: 0} : {})}).format(selectedPrice)
      : '';
    state.textContent = hasValidatedPrice ? panel.dataset.priceLabel : panel.dataset.onRequestLabel;
    const frameUnavailable = support === 'encadre' && !framedAvailable(format);
    const smallApproved = smallDocumented && smallTerms.enabled === true;
    const largeFrameQuote = panel.querySelector('[data-framed-large-quote]');
    if (largeFrameQuote) largeFrameQuote.hidden = support !== 'encadre' || panel.dataset.artworkRef === 'A12 V222';
    if (framedOrderInfo) {
      const preorderHeading = framedOrderInfo.querySelector('[data-preorder-heading]');
      if (preorderHeading) preorderHeading.textContent = preorderHeading.dataset.preorderHeading.replace('__DIMENSIONS__', label(selected));
      framedOrderInfo.hidden = support !== 'encadre' || selected.widthCm !== 32
        || panel.dataset.artworkRef === 'A12 V222' || !smallWindowValid;
    }
    if (frameUnavailable) state.textContent = framedUnavailableLabel;
    state.hidden = hasValidatedPrice && (!frameUnavailable || !!framedOrderInfo);
    note.textContent = [selected.note, isA13 ? null : product.orientationNote].filter(Boolean).join(' ');
    // Only the existing Shopify mapping can make a configuration purchasable.
    const purchase = panel.querySelector('[data-roscoff-purchase]');
    if (purchase) {
      const variantId = hasValidatedPrice && (!frameUnavailable || smallPrepared)
        ? catalog.shopifyVariantIds?.[panel.dataset.artworkRef]?.[support]?.[format] : null;
      purchase.hidden = !variantId;
      const enabled = !preopeningLocked && !!variantId && !frameUnavailable && (!smallPrepared || smallApproved);
      purchase.dataset.purchaseEnabled = String(enabled);
      purchase.dataset.preorder = String(smallPrepared && selected.widthCm === 32);
      purchase.dataset.acceptUntil = smallPrepared && selected.widthCm === 32 ? smallTerms?.acceptUntil || '' : '';
      const actionLabel = preopeningLocked ? preopeningLabel : smallPrepared && selected.widthCm === 32
        ? purchase.dataset.preorderLabel : purchase.dataset.addLabel;
      purchase.dataset.actionLabel = actionLabel;
      const action = purchase.querySelector('[data-cart-add]');
      action.textContent = actionLabel;
      action.disabled = !enabled;
      const deferred = smallPrepared && selected.widthCm === 32 && enabled;
      const deliveryProperty = purchase.querySelector('[data-deferred-delivery]');
      const paymentProperty = purchase.querySelector('[data-deferred-payment]');
      const validityProperty = purchase.querySelector('[data-deferred-validity]');
      validityProperty.disabled = !deferred;
      validityProperty.value = deferred ? smallTerms.acceptUntil : '';
      deliveryProperty.disabled = !deferred;
      deliveryProperty.value = deferred ? smallTerms.deliveryText.trim() : '';
      paymentProperty.disabled = !deferred;
      const notice = purchase.querySelector('[data-small-framed-notice]');
      notice.hidden = !smallPrepared || (selected.widthCm !== 32 && !smallDocumented);
      notice.textContent = smallPrepared && !smallWindowValid ? notice.dataset.expiredLabel
        : smallDocumented ? (selected.widthCm === 32 ? notice.dataset.deferredIntro : '') : '';
      if (!notice.textContent) notice.hidden = true;

      const changed = purchase.dataset.variantId !== String(variantId || '');
      purchase.dataset.variantId = String(variantId || '');
      purchase.querySelector('[name="id"]').value = variantId || '';
      if (changed) {
        purchase.querySelector('[name="quantity"]').value = '1';
        purchase.querySelector('[data-cart-feedback]').textContent = '';
        purchase.querySelector('[data-cart-success-link]').hidden = true;
      }
      purchase.dispatchEvent(new CustomEvent('roscoff:configuration'));
    }
    // Checkout remains closed; this form only uses the Shopify Ajax cart API.
  }
  supportButtons.forEach((button) => button.addEventListener('click', () => {
    support = button.dataset.support;
    swipeJustEnded = false;
    touchStart = null;
    if (product.supports[support][format]?.availability !== 'available') {
      format = catalog.formats.find(item => product.supports[support][item.id]?.availability === 'available')?.id;
    }
    renderPreviews();
    render();
  }));
  renderPreviews();
  render();
  setInterval(() => {
    if (support === 'encadre' && product.supports[support][format]?.widthCm === 32) render();
  }, 60000);
})();
















